import React from 'react';
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

function Linkpages(props) {
    const {t} = useTranslation("common");
    return (
        <div className="linkpages">
                 <div className="link"><Link to={'/'}>{t('menu.home')}</Link> </div>
                 <div className="link"><Link to={'/about'}>{t('menu.about')}</Link></div>
                 <div className="link"><Link to={'/services'}>{t('menu.services')}</Link></div>
                 <div className="link"><Link to={'/blog'}>{t('menu.blog')}</Link></div>
                 <div className="link"><Link to={'/contact'}>{t('menu.contact')}</Link></div>
            </div>

    );
}

export default Linkpages;

//
// import React, { useState } from 'react'; // Ավելացրինք useState
// import { Link } from "react-router-dom";
// import { useTranslation } from "react-i18next";
//
// function Linkpages(props) {
//     const { t } = useTranslation("common");
//
//     // Ստեղծում ենք վիճակ (state) մենյուի համար
//     const [isOpen, setIsOpen] = useState(false);
//
//     return (
//         <>
//             {/* Hamburger կոճակը, որը կերևա միայն մոբայլում */}
//             <div className={`hamburger ${isOpen ? "open" : ""}`} onClick={() => setIsOpen(!isOpen)}>
//                 <span></span>
//                 <span></span>
//                 <span></span>
//             </div>
//
//             {/* Մենյուի բլոկը. եթե isOpen-ը true է, ավելանում է 'active' դասը */}
//             <div className={`linkpages ${isOpen ? "active" : ""}`}>
//                 <div className="link"><Link to={'/'} onClick={() => setIsOpen(false)}>{t('menu.home')}</Link> </div>
//                 <div className="link"><Link to={'/about'} onClick={() => setIsOpen(false)}>{t('menu.about')}</Link></div>
//                 <div className="link"><Link to={'/services'} onClick={() => setIsOpen(false)}>{t('menu.services')}</Link></div>
//                 <div className="link"><Link to={'/blog'} onClick={() => setIsOpen(false)}>{t('menu.blog')}</Link></div>
//                 <div className="link"><Link to={'/contact'} onClick={() => setIsOpen(false)}>{t('menu.contact')}</Link></div>
//             </div>
//
//             {/* Ֆոնը մթնեցնելու համար (Background Overlay), երբ մենյուն բաց է */}
//             {isOpen && <div className="menu-overlay" onClick={() => setIsOpen(false)}></div>}
//         </>
//     );
// }
//
// export default Linkpages;